import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSessionExpired } from '@/services/queries';
import { isAuthPath, sessionExpiredUrl } from './paths';

/**
 * CK-02 / AU-02: when the session expires during the visit (an expired token before an authed call, or a 401
 * to a request that carried it), the interface is already signed out (`useSessionExpired`) and the user is sent
 * to sign in with `?session=expired&redirect=<where they were>`; signing in brings them back there. Nothing
 * happens on the auth pages themselves (the old site's `redirectToLogin`).
 */
export function SessionExpiry() {
  const navigate = useNavigate();
  const location = useLocation();
  const here = useRef(location);
  useEffect(() => {
    here.current = location;
  }, [location]);

  useSessionExpired(() => {
    const { pathname, search } = here.current;
    if (isAuthPath(pathname)) return;
    void navigate(sessionExpiredUrl(pathname + search));
  });
  return null;
}
